<template>
  <b-sidebar v-model="visible" backdrop id="expense_type" width="50rem" no-header right shadow :aria-label="lang.status_settings">
    <template #default="{hide}">
      <div class="p-3" :style="`direction:${lang.dir}`">
        <b-button size="sm" variant="danger" :disabled="saving" @click="hide">{{lang.close}}</b-button>
        <h5>{{lang.status_settings}}</h5>
        <label>{{lang.status_name_ar}}</label><b-form-input :disabled="saving" v-model="name_ar" maxlength="255" />
        <label>{{lang.status_name_en}}</label><b-form-input :disabled="saving" v-model="name_en" maxlength="255" />
        <div v-if="editingPhrase==='itemTypes'"><label>{{lang.status_points_per_100}}</label><b-form-input :disabled="saving" v-model="options.points_per_100" type="number" min="0" step="0.01" /></div>
        <v-row><v-col cols="12" md="6"><label>{{lang.background}}</label><v-color-picker :disabled="saving" v-model="bgColor" /></v-col>
        <v-col cols="12" md="6"><label>{{lang.font_color}}</label><v-color-picker :disabled="saving" v-model="color" /></v-col></v-row>
      </div>
    </template>
    <template #footer><b-button :disabled="saving" class="m-2" variant="success" @click="CreateNew()">{{saving?lang.status_saving:lang.save}}</b-button></template>
  </b-sidebar>
</template>
<script>
import axios from 'axios';
export default {
  data(){return {id:0,name_ar:'',name_en:'',options:{points_per_100:0},bgColor:'#ffffff',color:'#000000',editingPhrase:'',saving:false,visible:false};},
  computed:{
        lang: function(){
            if(this.$cookies.get(this.$store.state.LangCooki) != null){
                if(this.$cookies.get(this.$store.state.LangCooki)  == 'en'){
                    return this.$store.state.lang.en;
                }else if(this.$cookies.get(this.$store.state.LangCooki)  == 'ur'){
                    return this.$store.state.lang.ur;
                }else{
                    return this.$store.state.lang.ar;
                }
            }
            else if(this.$store.state.deflang == 'en'){
                return this.$store.state.lang.en;
            }
            else if(this.$store.state.deflang == 'ur'){
                return this.$store.state.lang.ur;
            }else{
                return this.$store.state.lang.ar;
            }
        },
  },
  methods:{
    resetValues(item,phrase){
      this.id=Number(item.id)||0;this.name_ar=item.name_ar||'';this.name_en=item.name_en||'';
      this.options={points_per_100:item.options?.points_per_100??0};this.bgColor=item.bgColor||'#ffffff';this.color=item.color||'#000000';this.editingPhrase=phrase||this.$parent.currentStatus;
    },
    async CreateNew(){
      if(this.saving)return false;
      if(!this.name_ar.trim()||!this.name_en.trim()){this.$snotify.error(this.lang.name_ar_en_required,this.lang.alert);return false;}
      const phrase=this.editingPhrase,id=this.id;const post=new FormData();post.append('type','saveStatusOption');post.append('auth',this.$cookies.get(this.$store.state.COOKIEPhase));post.append('defBranch',localStorage.getItem('defBranch'));
      for(const [key,value] of Object.entries({phrase,id,name_ar:this.name_ar,name_en:this.name_en,bgColor:this.bgColor,color:this.color}))post.append('data['+key+']',value);
      if(phrase==='itemTypes')post.append('data[points_per_100]',this.options.points_per_100);
      this.saving=true;
      try{const {data}=await axios.post(this.$store.state.SAMCOTEC.r_path,post);const row=data?.results?.data;
        if(Number(data?.error?.number)!==200||!Number.isInteger(Number(row?.id))||Number(row.id)<1||(id>0&&Number(row.id)!==id)||row.option_phrase!==phrase)throw new Error('invalid');
        this.id=Number(row.id);await this.$parent.statusSaved?.(row,phrase);
        if(!this.$parent.statusSaved)await this.$parent.getExpensesTypes();
        this.$snotify.success(this.lang.status_saved,this.lang.alert);this.visible=false;return true;
      }catch(error){this.$snotify.error(this.lang[error.response?.data?.error?.code]||this.lang.status_save_failed,this.lang.alert);return false;}
      finally{this.saving=false;}
    },
  },
}
</script>
